import api from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

function subToPlain(sub) {
  const json = sub.toJSON();
  return {
    endpoint: json.endpoint,
    keys: json.keys || { p256dh: "", auth: "" },
  };
}

export function getPushSupport() {
  if (typeof window === "undefined") return { supported: false, reason: "no-window" };
  if (!("serviceWorker" in navigator)) return { supported: false, reason: "no-sw" };
  if (!("PushManager" in window)) return { supported: false, reason: "no-push" };
  if (!("Notification" in window)) return { supported: false, reason: "no-notification" };
  return { supported: true };
}

export async function getNotificationPermission() {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission;
}

export async function getExistingSubscription() {
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    return sub || null;
  } catch {
    return null;
  }
}

export async function enablePush() {
  const support = getPushSupport();
  if (!support.supported) {
    return { ok: false, reason: support.reason };
  }
  if (Notification.permission === "denied") {
    return { ok: false, reason: "denied" };
  }
  // Ask permission
  let permission = Notification.permission;
  if (permission === "default") {
    permission = await Notification.requestPermission();
  }
  if (permission !== "granted") {
    return { ok: false, reason: permission };
  }

  // Fetch VAPID key
  const { data: vapid } = await api.get("/push/vapid-public-key");
  if (!vapid?.key) return { ok: false, reason: "no-vapid" };

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapid.key),
    });
  }
  await api.post("/push/subscribe", subToPlain(sub));
  return { ok: true };
}

export async function disablePush() {
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      const plain = subToPlain(sub);
      try { await api.post("/push/unsubscribe", plain); } catch {}
      try { await sub.unsubscribe(); } catch {}
    }
    return { ok: true };
  } catch {
    return { ok: false };
  }
}
